import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['area']

  switch(event) {
    const { name } = event.params
    // 押下したタブ要素の位置を記録
    const tab = event.currentTarget.getBoundingClientRect()
    const offsetTop = tab.top

    // タブ切り替え
    this.areaTargets.forEach(el => {
      if (el.dataset.name === name) {
        el.classList.add(el.dataset.klass)
      } else {
        el.classList.remove(el.dataset.klass)
      }
    })

    // タブ切り替え後、切り替え前の位置に調整
    const newTab = event.currentTarget.getBoundingClientRect()
    window.scrollBy(0, newTab.top - offsetTop)
  }
}